import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class XpressCenterService {
    constructor(
        private apiHttp: ApiHttp) {
    }

    public getXpressCenters(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetXpressCenters', data, messageService);
    }

    public getXpressCenterUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetXpressCenterUsers', data, messageService);
    }

    public getXpressCenterFreeUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetXpressCenterFreeUsers', data, messageService);
    }

    public addEmployeeToCenter(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/AddEmployeeToCenter', data, messageService);
    }

    public removeEmployeeFromCenter(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/RemoveEmployeeFromCenter', data, messageService);
    }

    public getCenterOperationHours(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetCenterOperationHours', data, messageService);
    }

    public getCenterHolidayHours(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetCenterHolidayHours', data, messageService);
    }

    public removeHolidayFromCenter(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/RemoveHolidayFromCenter', data, messageService);
    }

    public addHolidayHoursToCenter(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/AddHolidayHoursToCenter', data, messageService);
    }

    public saveOperationDaysChanges(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/SaveOperationDaysChanges', data, messageService);
    }

    public getTrainingSchedule(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetXpressCenterTrainingSchedule', data, messageService);
    }

    public removeTraining(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/RemoveTraining', data, messageService);
    }

    public addTraining(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/AddTrainingToCenter', data, messageService);
    }

    public saveTrainingClassroomInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/SaveTrainingClassroomInfo', data, messageService);
    }

    public saveCenterProdileInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/SaveCenterProfileInfo', data, messageService);
    }

    public createXpressCenter(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/CreateXpressCenter', data, messageService);
    }

    public getRiderScheduleCalendar(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetRiderScheduleCalendar', data, messageService);
    }

    public removeXpressCenter(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/RemoveXpressCenter', data, messageService);
    }

    public getLastTrainingCenterByVehicleAndServiceType(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/GetLastTrainingCenterByVehicleAndServiceType', data, messageService);
    }

    public rescheduleTrainingCenter(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressCenter/RescheduleTrainingCenter', data, messageService);
    }
}
